/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useCallback, useState } from 'react';
import { UseCacheResult } from './useCache.types';

export const useCache = (): UseCacheResult => {
  const [cacheKey, setCacheKey] = useState('');
  const clearCache = useCallback(() => {
    setCacheKey(new Date().toISOString());
  }, []);

  return { cacheKey, clearCache };
};
